import { useContext } from 'react';

import { NetworkContext } from './NetworkProvider';

export default function useNetwork(): { isOnline: boolean } {
  const context = useContext(NetworkContext);
  if (context === undefined) {
    throw new Error('useNetwork must be used within an NetworkProvider');
  }
  return context;
}

export { NetworkContext, useNetwork };
